import { render, staticRenderFns } from "./NonTransferablePage.vue?vue&type=template&id=2dcb5834&"
import script from "./NonTransferablePage.vue?vue&type=script&lang=ts&"
export * from "./NonTransferablePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports